import React from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { Doodle } from './Doodle';
import { ImagePlaceholder } from './ImagePlaceholder';
import { assets, bonuses } from '../data/landing';
type ProductMockupProps = {
  tone?: 'light' | 'dark';
  eager?: boolean;
  decorated?: boolean;
  className?: string;
};
export function ProductMockup({
  tone = 'light',
  eager = false,
  decorated = true,
  className
}: ProductMockupProps) {
  const dark = tone === 'dark';
  const hasMockup = Boolean(assets.mainMockup);
  return <div className={twMerge('relative', className)} data-id="element-305" data-mp="3c8eewwsf9odt">
      {decorated && <>
          {!dark && <span aria-hidden="true" className="absolute -inset-x-3 -bottom-4 top-10 rotate-2 rounded-[2.5rem] bg-teal-light/35 sm:-inset-x-5" data-id="element-306" data-mp="32c2wrq65i4bg" />}
          <Doodle kind="leaf" className="absolute -left-4 top-6 z-10 hidden h-9 w-9 -rotate-12 sm:block" data-id="element-307" data-mp="1qww77yrappk5" />
          <Doodle kind="heart" className="absolute -right-4 top-[40%] z-10 hidden h-7 w-7 rotate-12 sm:block" data-id="element-308" data-mp="j3b78zk37g5i" />
          <Doodle kind="rays" className="absolute -left-7 bottom-16 z-10 hidden h-8 w-8 -rotate-90 sm:block" data-id="element-309" data-mp="o2o48d4oa3lt" />
          <Doodle kind="sparkle" className="absolute -right-1 -top-9 hidden h-5 w-5 sm:block" data-id="element-310" data-mp="95negf61kipz" />
        </>}

      <div className={twMerge('relative rounded-[1.75rem]', hasMockup ? 'p-2 sm:p-3' : 'p-3 sm:p-5', dark ? 'bg-white/[0.07] ring-1 ring-white/15' : 'border border-teal-soft bg-white shadow-soft')} data-id="element-311" data-mp="e2nheh7lh5cv">
        {hasMockup ? <img src={assets.mainMockup} alt="30 Días de Viandas Resueltas de Viandas Express 15’, junto a los 5 bonos digitales incluidos" width={1313} height={1198} loading={eager ? 'eager' : 'lazy'} decoding="async" className="block h-auto w-full rounded-[20px]" data-id="element-312" data-mp="3mkjnxg32w9yn" /> : <>
            <ImagePlaceholder alt="Mockup de 30 Días de Viandas Resueltas" label="[INSERTAR MOCKUP PRINCIPAL]" hint="30 Días de Viandas Resueltas · PNG con fondo transparente" icon={BookOpenIcon} aspectClass="aspect-[6/5]" size="lg" tone={tone} eager={eager} data-id="element-313" data-mp="1o2giq5h04rvb" />

            <div className="mt-3 grid grid-cols-5 gap-2 sm:gap-3" data-id="element-314" data-mp="270ke7x3yusen">
              {bonuses.map(b => <ImagePlaceholder key={b.number} src={b.image} alt={`Mockup del bono ${b.title}`} label={`Bono #${b.number}`} icon={b.icon} aspectClass="aspect-[3/4]" size="sm" tone={tone} eager={eager} data-id="element-315" data-mp="221zfk24d4gsb" />)}
            </div>

            <div className="absolute -top-4 right-4 flex items-center gap-1.5 rounded-full bg-pink px-4 py-2 font-display text-xs font-extrabold uppercase tracking-wide text-white shadow-cta sm:right-6 sm:text-sm" data-id="element-316" data-mp="hlmkewoecbmj">
              <GiftIcon aria-hidden="true" className="h-4 w-4" data-id="element-317" data-mp="2xbmglkrjkcbf" />+ 5 bonos digitales incluidos
            </div>
          </>}
      </div>
    </div>;
}